import { number } from "common/formats";

export const dataSelectors = {
    sent_count: {
        title: "Sent count",
        description: "Total number of emails sent.",
        dataField: "sent_count",
        formatter: number
    },
    
    delivered_count: {
        title: "Delivered count",
        description: "The total number of unique emails delivered to the recipient.",
        dataField: "delivered_count",
        formatter: number
    },
    
    bounce_count: {
        title: "Bounce count",
        description: "The number of emails sent that could not be successfully delivered to the recipient's inbox.",
        dataField: "bounce_count",
        formatter: number
    },
    
    open_count: {
        title: "Open count",
        description: "The number of recipients who open a given email.",
        dataField: "open_count",
        formatter: number
    },
    
    click_count: {
        title: "Click count",
        description: "The number of recipients who clicked on one or more links contained in a given email.",
        dataField: "click_count",
        formatter: number
    }
};
